module.exports = __webpack_public_path__ + "img/what_is_engineering_splash.2fb8cbd2.jpg";